import type { FC, ReactNode } from "react";
import { Stack } from "@mui/material";
import { ErrorNotPermitted } from "../../root/error/ErrorPage";
import { AssistantHistorySidebar } from "./AssistantHistorySidebar";
import { AssistantServiceBanner } from "./AssistantServiceBanner";
import { useAssistantAccess } from "../../shared/assistantAccess";
import { OrganisationAssistantApi } from "./AssistantApiContext";
import { AssistantInviteDrawer, AssistantInviteDrawerProvider } from "./AssistantInviteDrawer";

type AssistantLayoutProps = { children: ReactNode; currentConversationId?: string };

export const AssistantLayout: FC<AssistantLayoutProps> = ({ children, currentConversationId }) => {
  const hasAccess = useAssistantAccess();

  if (!hasAccess) return <ErrorNotPermitted isAuthenticated />;

  return (
    <OrganisationAssistantApi>
      <AssistantInviteDrawerProvider>
        <Stack direction="row" sx={{ height: "100dvh", minHeight: 0 }}>
          <AssistantHistorySidebar currentConversationId={currentConversationId} />
          <Stack sx={{ flex: 1, minWidth: 0, minHeight: 0 }}>
            <AssistantServiceBanner />
            {children}
          </Stack>
        </Stack>
        <AssistantInviteDrawer />
      </AssistantInviteDrawerProvider>
    </OrganisationAssistantApi>
  );
};
